
export default function TeamMembers() {
  const teamMembers = [
    {
      id: 1,
      name: "Steven Vine",
      position: "Co-Founder",
      qualifications: "EngTech MICE",
      experience: "20+ years",
      description: "Steven Vine is an Engineering Technician (EnTech) with the Institution of Civil Engineers (ICE UK) and has over 20 years of expertise in civil engineering projects across the UK. He has led and overseen complex developments, providing strategic guidance and technical oversight to ensure practical, buildable, and compliant solutions.",
      image: "https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/6fd533dab0a96e1b5230124978dca138.jpeg"
    },
    {
      id: 2,
      name: "Violeta Ivanova",
      position: "Co-Founder",
      qualifications: "MEng CEng MICE",
      experience: "12+ years",
      description: "Violeta Ivanova has over 12 years of civil engineering design experience in Bulgaria and the UK. She holds a master’s degree in Transportation Engineering, specialising in Highways Design and Construction. Violeta is chartered with the Institution of Civil Engineers (ICE UK) and a member of Bulgaria’s Chamber of Engineers in the Investment Design (KIIP), which is a full member of the European Council of Engineers Chambers (ECEC).",
      image: "https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/f68be083a883a667c843a9d7bb834625.jpeg"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Meet the Team
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our team brings decades of experience and engineering expertise to deliver consistent results on every project.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {teamMembers.map((member) => (
            <div key={member.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="md:flex">
                <div className="md:w-2/5">
                  <img 
                    src={member.image}
                    alt={member.name}
                    className="w-full h-80 md:h-full object-cover object-top"
                  />
                </div>
                <div className="md:w-3/5 p-8">
                  <div className="mb-4">
                    <h3 className="text-2xl font-bold text-gray-800 mb-2">{member.name}</h3>
                    <p className="text-lg font-semibold mb-2" style={{ color: '#0B8D72' }}>
                      {member.position}
                    </p>
                    <p className="text-sm text-gray-600 mb-2">{member.qualifications}</p>
                    <p className="text-sm text-gray-600 mb-4">Experience: {member.experience}</p>
                  </div>

                  <p className="text-sm text-gray-600 leading-relaxed">
                    {member.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
